export const getH5ConfiguratorLink = (carCode, carType) => {
    let env = '';
    if (process.browser) {
        env = window && window.env;
    }
    let configuratorParam = carCode.toUpperCase();
    if (configuratorParam === 'ES8' || configuratorParam === 'ARIES') {
        configuratorParam = 'ES8?newVersion=2';
    } else {
        configuratorParam = (carType || carCode).toUpperCase();
    }
    switch (env) {
        case 'dev':
            return `https://configh5-qa.nio.com/car-config/version?type=${configuratorParam}`;
        case 'test':
            return `https://configh5-sit.nio.com/car-config/version?type=${configuratorParam}`;
        case 'stg':
            return `https://configh5-stg.nio.com/car-config/version?type=${configuratorParam}`;
        default:
            return `https://configh5.nio.com/car-config/version?type=${configuratorParam}`;
    }
};

export const getAppConfiguratorLink = (carCode, carType) => {
    const configuratorParam = carCode.toUpperCase();
    if (configuratorParam === 'ES8' || configuratorParam === 'ARIES') {
        return 'nio://cars.vom/select?carSeries=ES8&newVersion=2';
    }
    return `nio://cars.vom/select?carSeries=${(carType || carCode).toUpperCase()}`;
};



// WEBPACK FOOTER //
// ./src/util/car.js